import React from 'react'
import { Switch } from 'react-router'
import { Router, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import appReducer from './reducers/index'
import TimeSheet from './containers/TimeSheet'
import { createBrowserHistory } from 'history'
import LoginPage from './containers/LoginPage'
import UsersPage from './containers/UsersPage'
import HomePage from './containers/HomePage'
import MapPage from './containers/MapPage'
import FaqPage from './containers/FaqPage'
import VendorReport from './containers/VendorReport'
import ForgotLandingPage from './containers/ForgotLandingPage'
import PrivateRoute from './components/PrivateRoute'
import DateFnsUtils from '@date-io/date-fns/build/index'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import 'devextreme/dist/css/dx.light.css'

const [appContext] = window.location.pathname
const getUserConfirmation = (message, callback) => {
  callback(window.confirm(message))
}
const history = createBrowserHistory(
  {
    basename: appContext,
    forceRefresh: false,
    getUserConfirmation
  }
)
window.History = history

export default function Root() {
  return (
    <Provider store={appReducer()}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Router history={history} getUserConfirmation={getUserConfirmation}>
          <Switch>
            <Route key="0" path="/login" exact component={LoginPage} />
            <PrivateRoute key="1" path="/" exact component={HomePage} />
            <PrivateRoute key="2" path="/users" exact component={UsersPage} />
            <PrivateRoute key="3" path="/time-sheet" exact component={TimeSheet} />
            <PrivateRoute key="4" path="/map" exact component={MapPage} />
            <PrivateRoute key='5' path='/logins' exact component={VendorReport} />
            <PrivateRoute key="6" path="/help" exact component={FaqPage} />
            <Route key="7" path="/forgot" exact component={ForgotLandingPage} />
          </Switch>
        </Router>
      </MuiPickersUtilsProvider>
    </Provider>
  )
}